import React from 'react';
import { Box, Typography } from '@mui/material';


export const SummaryScore: React.VFC<{ score: number }> = ({ score }) => {
  const scoreLevel = React.useMemo(() => {
    if (score >= 90) {
      return 'excellent';
    }

    if (score > 80) {
      return 'good';
    }

    if (score > 70) {
      return 'improvementNeeded';
    }

    return 'failed';
  }, [ score ]);

  const scoreLabel = {
    'excellent': 'Excellent',
    'good': 'Good',
    'improvementNeeded': 'Improvement Needed',
    'failed': 'Failed',
  }[scoreLevel];
  const scoreColor = {
    'excellent': 'success',
    'good': 'info',
    'improvementNeeded': 'warning',
    'failed': 'error',
  }[scoreLevel];
  const colorText = `${scoreColor}.main`;
  const colorBg = `${scoreColor}.background`;

  return (
    <Box
      sx={{
        mr: 2,
        width: '70px',
        height: '70px',
        borderRadius: 999,
        bgcolor: colorBg,
        p: 2,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <Typography
        variant="h3"
        fontWeight={700}
        lineHeight={1}
        sx={{
          pt: 1.5,
          color: colorText,
        }}
      >
        {score}%
      </Typography>
      <Typography sx={{ mt: -1, color: colorText, fontSize: 12 }}>
        {scoreLabel}
      </Typography>
    </Box>
  );
};
